import React, { useState } from 'react';
import './index.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import PilgrimServices from './components/PilgrimServices';
import ScheduleAndUpdates from './components/ScheduleAndUpdates';
import SacredAbode from './components/SacredAbode';
import TempleGallery from './components/TempleGallery';
import MapSection from './components/MapSection';
import Footer from './components/Footer';
import TempleHistoryModal from './components/TempleHistoryModal';

function App() {
  const whatsappNumber = "8790357714";
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

  return (
    <div className="App">
      <Header />
      <section id="home">
        <HeroSection />
      </section>

      {/* Main content will go here */}
      <main>
        <section id="services">
          <PilgrimServices />
        </section>
        <section id="schedule">
          <ScheduleAndUpdates />
        </section>
        <section id="about-temple">
          <SacredAbode onShowHistory={() => setIsHistoryModalOpen(true)} />
        </section>
        <section id="gallery">
          <TempleGallery />
        </section>
        <section id="contact">
          <MapSection />
        </section>
      </main>

      {/* WhatsApp Floating Action Button */}
      <a
        href={whatsappLink}
        className="whatsapp-fab"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      <footer id="footer">
        <Footer />
      </footer>

      <TempleHistoryModal 
        isOpen={isHistoryModalOpen} 
        onClose={() => setIsHistoryModalOpen(false)} 
      />
    </div>
  );
}

export default App;
